module.exports = __webpack_public_path__ + "static/media/motion.ec44d12e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/motion.svg
// module id = 179
// module chunks = 0